import React from 'react';
import { InstagramLogo, FacebookLogo, TwitterLogo, TiktokLogo, YoutubeLogo } from '@phosphor-icons/react';

const SOCIALS = [
  { Icon: InstagramLogo, label: 'Instagram' },
  { Icon: FacebookLogo, label: 'Facebook' },
  { Icon: TwitterLogo, label: 'X / Twitter' },
  { Icon: TiktokLogo, label: 'TikTok' },
  { Icon: YoutubeLogo, label: 'YouTube' },
];

const SocialFooter = () => (
  <div className="border-t border-border mt-8 pt-5 pb-3">
    <div className="flex items-center justify-center gap-5">
      {SOCIALS.map(({ Icon, label }) => (
        <span
          key={label}
          className="w-9 h-9 rounded-full bg-card border border-border flex items-center justify-center text-muted-foreground hover:text-[#D4AF37] hover:border-[#D4AF37]/30 transition-colors cursor-default"
          title={label}
          data-testid={`social-${label.toLowerCase().replace(/[^a-z]/g, '')}`}
        >
          <Icon weight="regular" className="w-4 h-4" />
        </span>
      ))}
    </div>
    <p className="text-center text-[9px] text-muted-foreground mt-3 tracking-wider uppercase">Follow Track365</p>
  </div>
);

export default SocialFooter;
